const selectedEnvironment = 'staging';   // Set 'development' , 'production',  or 'staging'

/** S3 storage base URL – use when building full document URLs from keys (e.g. merge/upload-or-merge responses). */
export const S3_BASE_URL = 'https://xtram.s3.il-central-1.amazonaws.com';

/**
 * Xtram AI Chatbot API root (scheme + host + optional path prefix).
 * Local: http://localhost:5010
 * Behind path-based ALB: set REACT_APP_XTRAM_BOT_API_URL=https://chat.xtram.co.il/chatbot (no trailing slash).
 */
const rawXtramBotApiUrl = process.env.REACT_APP_XTRAM_BOT_API_URL || 'http://localhost:5010';
export const XTRAM_BOT_API_URL = 'https://chat.xtram.co.il/chatbot';

/** Xtram AI Chatbot upload constraints (used by the UI only). */
export const XTRAM_BOT_MAX_UPLOAD_MB = 10;
export const XTRAM_BOT_ALLOWED_EXTENSIONS = [
  'pdf', 'txt', 'md', 'csv', 'json',
  'doc', 'docx', 'xls', 'xlsx',
  'png', 'jpg', 'jpeg', 'webp',
];

/**
 * Xtram AI Audit API (xtram-ai-agent-v2 FastAPI) base URL.
 * Local: http://localhost:8091
 * Deploy: set REACT_APP_XTRAM_AUDIT_API_URL=https://audit.xtram.co.il
 */
export const XTRAM_AUDIT_API_URL = 'https://audit.xtram.co.il';
// export const XTRAM_AUDIT_API_URL = 'http://localhost:8092';

/**
 * Public legal pages on the marketing site. The clearing providers' site review
 * (Grow "אישור אתר לסליקה") requires the terms link to sit beside the consent
 * checkbox on every payment page, so these are read by the payment panels.
 */
export const TERMS_URL = 'https://www.xtram.co.il/payment-terms';
export const PRIVACY_URL = 'https://www.xtram.co.il/privacy';

/**
 * Version stamp of the published תקנון. Bump it whenever the terms text changes
 * so an acceptance can be traced back to the wording the payer actually saw.
 */
export const TERMS_VERSION = '2026-08';

/**
 * Local template authoring studio (financial-report-template-studio, Vite :5178).
 * Override with REACT_APP_TEMPLATE_STUDIO_URL when needed.
 */
export const TEMPLATE_STUDIO_URL =
  process.env.REACT_APP_TEMPLATE_STUDIO_URL || 'http://localhost:5178';

/**
 * OCR field boxes over the document preview (EditModal / payment acceptance modal).
 * On by default — documents without stored boxes look exactly as before.
 * Kill switch: REACT_APP_FIELD_BOXES_ENABLED=false.
 */
export const FIELD_BOXES_ENABLED = process.env.REACT_APP_FIELD_BOXES_ENABLED !== 'false';

export default selectedEnvironment;